import { Injectable } from '@angular/core';
import { IFeatureParams, IFlagFeature, IToggleContainer } from '@cemex-core/cmx-rollout-toggle-v1';
import { Features } from 'app/shared/app-features/models/features.enum';

@Injectable()
export class HideProductCodeRmxFeature implements IFlagFeature {
  name = Features.HIDE_PRODUCT_CODE_RMX;

  public isEnabled(container: IToggleContainer, params: IFeatureParams): boolean {
    return container[this.name].isEnabled();
  }
}
